import { CompetitionRegistrations } from './components/competition-registrations';
import { useCompetitionQuery } from '~/pages/competition/queries';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { Button } from '~/components/Button/Button';
import { Link } from '~/components/Link/Link';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { data } = useCompetitionQuery(id);
  const { can } = useAuthentication();

  if (!data) {
    return null;
  }

  const checkForClubAdmin = Boolean(
    data.open_externally && data.reg_deadline && new Date(data.reg_deadline) > new Date()
  );

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={data.name} />
        <Button.Group neutral>
          {can('list-competition-registration', id, checkForClubAdmin) && (
            <Link to="manage">
              <Button type="button">Hantera anmälningar</Button>
            </Link>
          )}
        </Button.Group>
      </PageLayout.Header>

      <PageLayout.Section>
        <CompetitionRegistrations competitionId={id} isTeamComp={data.is_team_comp ?? false} />
      </PageLayout.Section>
    </Fragment>
  );
}
